import { render, staticRenderFns } from "./cdcb.vue?vue&type=template&id=512a3e5e&scoped=true"
import script from "./cdcb.vue?vue&type=script&lang=js"
export * from "./cdcb.vue?vue&type=script&lang=js"
import style0 from "./cdcb.vue?vue&type=style&index=0&id=512a3e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a3e5e",
  null
  
)

export default component.exports